import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { api, formatErr } from "../../lib/api";

export const WelcomeSettingsDialog = ({ open, onOpenChange }) => {
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) api.get("/admin/onboarding-settings").then((r) => setMsg(r.data.default_welcome_message)).catch((e) => toast.error(formatErr(e))); }, [open]);
  const save = async () => {
    setBusy(true);
    try { await api.put("/admin/onboarding-settings", { default_welcome_message: msg }); toast.success("Mensaje predeterminado guardado"); onOpenChange(false); }
    catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl" style={{ background: "#0a0a0a", border: "1px solid rgba(255,255,255,0.1)", color: "#fff" }} data-testid="onb-settings-dialog">
        <DialogHeader><DialogTitle style={{ fontFamily: "Bebas Neue, sans-serif", fontSize: 26, letterSpacing: "0.05em" }}>Mensaje de bienvenida predeterminado</DialogTitle></DialogHeader>
        <p style={{ fontSize: 13, color: "#a3a3a3" }}>Se usa al crear cada incorporación y luego puedes personalizarlo para cada futbolista. Escribe {"{nombre}"} para insertar su nombre.</p>
        <textarea className="qv-input" rows={10} style={{ minHeight: 220, height: "auto" }} value={msg} onChange={(e) => setMsg(e.target.value)} data-testid="onb-settings-message" />
        <button className="qv-btn-primary" onClick={save} disabled={busy || !msg.trim()} style={{ justifyContent: "center" }} data-testid="onb-settings-save">{busy ? "Guardando…" : "Guardar"}</button>
      </DialogContent>
    </Dialog>
  );
};
